import * as React from 'react'

import { Checkbox, colors, NativeLink, spacing, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../../common'
import { i18nKeyPrefix } from '../../../../../i18n'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-REVIEW-NO-SHOW`

interface IProps {
  agreed: boolean
  validationHint?: string
  onChange: (agreed: boolean) => void
}

export default function NoShowPolicy(props: IProps) {
  const { agreed, validationHint, onChange } = props

  return (
    <div>
      <Checkbox
        label={<Label />}
        checked={agreed}
        invalid={!!validationHint && !agreed}
        onChange={onChange}
      />
      {validationHint && !agreed && (
        <div css={{ marginTop: spacing.majorScale(1) }}>
          <Text css={{ color: colors.text.error }}>{validationHint}</Text>
        </div>
      )}
    </div>
  )
}

function Label() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  return (
    <React.Fragment>
      <Text>{t(`${PRE}-TEXT`)}</Text>
      <NativeLink
        href="https://wonderschool.zendesk.com/hc/en-us/articles/360034235093-Wonderschool-No-Show-Policy"
        target="_blank"
      >
        {t(`${PRE}-LINK`)}
      </NativeLink>
    </React.Fragment>
  )
}
